export default "__VITE_ASSET__a1ea64b1__"